import {
  BILLING_TABS,
  resolveBillingTab,
} from "@/modules/billing/subscriptions/billingNavigation";

/** Browser tab title: "<what is open> · <section> — Sigma". */
export const APP_TITLE = "Sigma";

/** First path segment → section name (same names as the sidebar). */
const SECTION_BY_SEGMENT: Record<string, string> = {
  tickets: "Tickets",
  meetings: "Meetings",
  calendar: "Calendar",
  accounts: "Accounts",
  clients: "Accounts",
  contacts: "Accounts",
  companies: "Accounts",
  leads: "Pipeline",
  deals: "Projects",
  projects: "Projects",
  tasks: "Tasks",
  messages: "Messages",
  mail: "Mail",
  marketing: "Marketing",
  contracts: "Contracts",
  proposals: "Proposals",
  reports: "Reports",
  settings: "Settings",
  "web-monitor": "Web Monitor",
  hostinger: "Hostinger",
  "forms-v2": "Forms",
  apps: "Apps",
  platform: "Platform",
};

export const sectionTitleForLocation = (
  pathname: string,
  search = "",
): string | null => {
  const segment = pathname.split("/").filter(Boolean)[0] ?? "";
  if (!segment) return "Dashboard";
  if (segment === "billing") {
    const tab = resolveBillingTab(new URLSearchParams(search));
    return BILLING_TABS.find((entry) => entry.id === tab)?.label ?? "Billing";
  }
  return SECTION_BY_SEGMENT[segment] ?? null;
};

/** Specific first: a tab only shows the start of the title. */
export const buildDocumentTitle = (
  detail?: string | null,
  section?: string | null,
) => {
  const parts = [detail?.trim(), section?.trim()].filter(
    (part): part is string => Boolean(part),
  );
  // "INV-1 · Invoices" — skip the section when the detail already says it.
  const unique = parts.filter(
    (part, index) => index === 0 || !parts[0].includes(part),
  );
  return unique.length ? `${unique.join(" · ")} — ${APP_TITLE}` : APP_TITLE;
};
